<template>
  <div
    class="pendingOrder_wrapper"
    :class="{ 'filter-loading': filterLoading }"
  >
    <!-- 待处理订单页面 -->
    <van-nav-bar :title="orderTitle" @click-left="onBtnClick()">
      <template #left>
        <div class="icon">
          <span class="icon-cross"></span>
        </div>
      </template>
    </van-nav-bar>

    <!-- 信息列表 -->
    <div class="pendingOrder_BScroll">
      <div class="bscroll_box">
        <div
          class="pendingOrder_list"
          ref="pendingOrderScrollList"
          :class="{ line: showShadow }"
          @scroll="listScroll($event)"
        >
          <div class="pendingOrder_item">
            <div class="item_title">订单编号</div>
            <div class="item_content">{{ orderObj.id }}</div>
          </div>
          <div class="pendingOrder_item">
            <div class="item_title">车场名称</div>
            <div class="item_content">{{ orderObj.parkingName }}</div>
          </div>
          <!-- <div class="pendingOrder_item">
            <div class="item_title">岗位名称</div>
            <div class="item_content"></div>
          </div>-->
          <div class="pendingOrder_item item_parkingNumber_box">
            <div class="item_title">车位号</div>
            <div class="item_content item_parkingNumber">
              <span ref="parkingNumber"></span>
              <transition tag="div" name="slide">
                <div
                  @click="isShowNumberPop = false"
                  v-show="isShowNumberPop"
                  class="parkingNumber_pop"
                  ref="parkingNumberPop"
                ></div>
              </transition>
            </div>
            <div
              v-if="isShowNumberIcon"
              class="item_icon"
              @click="isShowNumberPop = !isShowNumberPop"
            >
              <span class="icon-screening"></span>
            </div>
          </div>
          <div class="pendingOrder_item">
            <div class="item_title">车牌号</div>
            <div class="item_content">{{ orderObj.plateNumber }}</div>
          </div>

          <div class="pendingOrder_item">
            <div class="item_title">停车时长</div>
            <div class="item_content">
              {{ orderObj.stayTime | timeTransformation }}
            </div>
          </div>

          <div class="pendingOrder_item">
            <div class="item_title">订单金额</div>
            <div class="item_content">{{ orderObj.orderAmount }}元</div>
          </div>
          <div class="pendingOrder_item">
            <div class="item_title">应收金额</div>
            <div class="item_content">{{ orderObj.payableAmount }}元</div>
          </div>
          <div class="pendingOrder_item">
            <div class="item_title">实收金额</div>
            <div class="item_content">{{ orderObj.payAmount }}元</div>
          </div>

          <div class="pendingOrder_item">
            <div class="item_title">出场方式</div>
            <div class="item_content">
              {{ orderObj.leaveWay | leaveWayFilter }}
            </div>
          </div>
          <div class="pendingOrder_item">
            <div class="item_title">入场时间</div>
            <div class="item_content">
              {{ orderObj.enterTime | dateFilter_yy_MM_dd_hh_mm_ss }}
            </div>
          </div>
          <div class="pendingOrder_item">
            <div class="item_title">出场时间</div>
            <div class="item_content">
              {{ orderObj.leaveTime | dateFilter_yy_MM_dd_hh_mm_ss }}
            </div>
          </div>
        </div>

        <div :class="{ center: isPaying }" class="pendingOrder_footer">
          <!-- 支付中展示页面 -->
          <div v-if="isPaying" class="payLoading">
            <span>支付中</span>
            <span class="point point1_animation"></span>
            <span class="point point2_animation"></span>
            <span class="point point3_animation"></span>
          </div>

          <!-- 页脚按钮 -->
          <div v-else class="footer_btn">
            <!-- 支付失败展示按钮 -->
            <div
              v-if="
                $condition.isOrderStatus_abnormal(orderStatus) && orderObj.id
              "
              class="fail_btn "
            >
              <div
                @click="syncOrderInfo(orderObj.id)"
                class="pendingOrder_pay_btn update_btn btn"
              >
                更新订单
              </div>
            </div>

            <!-- 订单异常展示按钮 -->
            <div
              v-if="$condition.isOrderStatus_fail(orderStatus) && orderObj.id"
              class="abnormal_btn"
            >
              <!-- <div @click="offline(orderObj.id)" class="pendingOrder_pay_btn">
                线下支付
              </div> -->
              <div
                @click="payAgain(orderObj.id)"
                class="pendingOrder_pay_btn payAgain btn"
              >
                再次支付
              </div>
            </div>

            <!-- 待处理订单展示按钮 -->
            <div
              v-if="
                $condition.isOrderStatus_pending(orderStatus) && orderObj.id
              "
              class="arrear_btn"
            >
              <!-- 应付金额不为零 -->
              <div
                v-if="orderObj.orderStatus != 0"
                @click="onShowQRCode()"
                class="pendingOrder_pay_btn btn"
                :class="{ disabled: isScanning }"
              >
                支 付
              </div>

              <!-- 应付金额为零 -->
              <div
                @click="onConfirm(orderObj.id)"
                v-else
                class="pendingOrder_pay_btn btn"
              >
                确 定
              </div>

              <!-- 页面底部按钮 -->
              <div class="footer_btn_box">
                <div
                  @click="onCancel(orderObj.id)"
                  class="continue_btn pendingOrder_btn btn"
                  :class="{ cancelBtnDisable: cancelBtnDisable }"
                >
                  继续计费
                </div>
                <div
                  v-if="orderObj.payableAmount != 0"
                  @click="onOwe(orderObj.id)"
                  class="arrear_btn pendingOrder_btn btn"
                >
                  欠费
                </div>
              </div>
            </div>

            <!-- 已支付展示按钮 -->
            <div
              v-if="
                $condition.isOrderStatus_success(orderStatus) && orderObj.id
              "
              class="success_btn"
            >
              <div
                @click="confirmExit(orderObj.id)"
                class="pendingOrder_pay_btn btn"
              >
                确认已离场
              </div>
              <div
                @click="onCancel(orderObj.id)"
                class="pendingOrder_pay_btn payAgain btn"
                :class="{ cancelBtnDisable: cancelBtnDisable }"
              >
                <!-- :class="{ disabled: disabledBtn, gray: disabledBtn }" -->

                继续计费
              </div>
            </div>

            <!-- 预付款展示按钮 -->
            <div
              v-if="
                $condition.isOrderStatus_advance(orderStatus) && orderObj.id
              "
              class="success_btn"
            >
              <div
                @click.prevent="confirmExit(orderObj.id)"
                class="pendingOrder_pay_btn btn"
              >
                确认已离场
              </div>
              <!-- 页面底部按钮 -->
              <div class="footer_btn_box">
                <div
                  @click="onCancel(orderObj.id)"
                  class="continue_btn pendingOrder_btn btn"
                  :class="{ cancelBtnDisable: cancelBtnDisable }"
                >
                  继续计费
                </div>
                <div
                  @click="onRefund(orderObj.id)"
                  class="arrear_btn pendingOrder_btn btn"
                >
                  退 款
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 二维码页面 -->
    <transition tag="div" name="pop">
      <qr-code
        v-show="showQRCode"
        @closeQRCode="closeQRCode"
        @failCallback="failCallback"
        @successCallback="successCallback"
        @onPay="payFunc"
        :showQRCode="showQRCode"
        :orderParkingId="orderParkingId"
        :isFirst="isFirst"
        :qrCodeInterFace="qrCodeInterFace"
      ></qr-code>
    </transition>
  </div>
</template>

<script>
import scanPayMixin from "../../utils/scanPayMixin";
import { Dialog, Toast } from "vant";
// import BScroll from "better-scroll";
import qrCode from "../../components/QRCode";
import JsBridge from "../../utils/JSBridge/JsBridge";
import {
  // ORDER_PARKING_FIND_ORDER_PARKING_OF_WAIT_HANDLE,
  ORDER_PARKING_CANCEL_ORDER,
  ORDER_PARKING_ARREAR_OPERATE,
  ORDER_PARKING_FINISH,
  ORDER_PARKING_REFUND,
  // ORDER_STATUS_FAILURE,
  ORDER_PARKING_OFFLINE_PAY,
  ORDER_PARKING_FIND_ORDER_PARKING_BY_ID,
  ORDER_PARKING_SYNC_ORDER_INFO,
  ORDER_PARKING_QRCODE,
  ORDER_PARKING_RECOVERY_QRCODE,
  ORDER_PARKING_RECOVERY_SCANCODE_PAY,
  // ORDER_PARKING_CHECK_PAY_IS_ALLOWED,
  ORDER_PARKING_SCANCODE_PAY,
  ORDER_STATUS_ABNORMAL,
  PARKING_SPACE_ENTER_OPERATOR_AGAIN,
  ORDER_PARKING_CONFIRM_IS_LEAVE
} from "../../config/config";
export default {
  mixins: [scanPayMixin],
  data: () => ({
    orderObj: {},

    //正在扫描
    isScanning: false,

    //支付中
    isPaying: false,

    //请求次数
    count: 0,

    //订单状态
    orderStatus: -1,

    showQRCode: false,

    isFirst: false,

    isRecovery: false,

    qrCodeInterFace: "",

    parkingNumber: "",

    isShowNumberPop: false,

    isShowNumberIcon: false,

    // disabledBtn: true,

    showShadow: true,

    cancelBtnDisable: false,

    filterLoading: false
  }),
  methods: {
    onRefund(orderParkingId) {
      Dialog.confirm({
        title: "系统提示",
        message: "<span style='font-size : 20px ;'>是否确认退款</span>"
      }).then(() => {
        this.$utils.showLoading();
        this.$request(ORDER_PARKING_REFUND, { orderParkingId }, res => {
          this.$utils.closeLoading();
          if (this.$condition.isRequestSuccess(res)) {
            this.pageInit();
            Dialog.alert({
              title: "系统提示",
              message: "<span style='font-size : 20px ;'>退款成功</span>"
            });
          }
        });
      });
    },

    //监听滚动
    listScroll() {
      // Toast('123')
      // Toast(this.$refs.pendingOrderScrollList.scrollTop + ',' + this.$refs.pendingOrderScrollList.clientHeight + ',' + this.$refs.pendingOrderScrollList.scrollHeight )
      let {
        scrollTop,
        clientHeight,
        scrollHeight
      } = this.$refs.pendingOrderScrollList;
      if (scrollHeight - (scrollTop + clientHeight) < 10) {
        this.showShadow = false;
        return;
      }

      this.showShadow = true;
    },

    // setTimeDisabled() {
    //   this.disabledTimer = setInterval(() => {
    //     let beforeT = new Date(this.orderObj.leaveTime).getTime();
    //     let nowT = Date.now();

    //     if (nowT - beforeT > 900000) {
    //       this.disabledBtn = false;

    //       clearInterval(this.disabledTimer);
    //     }
    //   }, 1000);
    // },

    confirmExit(orderParkingId) {
      if (orderParkingId) {
        Dialog.confirm({
          title: "系统提示",
          message: "<span style='font-size : 20px ;'>是否确认车辆已离场</span>"
        }).then(() => {
          this.$request(
            ORDER_PARKING_CONFIRM_IS_LEAVE,
            { orderParkingId },
            res => {
              if (this.$condition.isRequestSuccess(res)) {
                this.$utils.goBack();
              }
            }
          );
        });
      }
    },

    keyRegister(orderParkingId) {
      if (orderParkingId) {
        Dialog.confirm({
          title: "系统提示",
          message:
            "<span style='font-size : 20px ;'>确认车辆一键入场登记</span>"
        }).then(() => {
          this.$request(
            PARKING_SPACE_ENTER_OPERATOR_AGAIN,
            {
              orderParkingId
            },
            () => {
              this.$utils.goBack();
            }
          );
        });
      }
    },

    payFunc(id) {
      this.isFirst = false;
      this.onPay(id);
    },

    //再次支付
    payAgain() {
      if (this.isFirst) {
        Dialog.confirm({
          title: "系统提示",
          message:
            '<span style="font-size : 20px ;">点击确定，<br/>订单状态将发生改变</span>'
        }).then(() => {
          this.showQRCode = true;
        });
      } else {
        this.showQRCode = true;
      }
    },

    exceededPollingTimes() {
      this.orderStatus = ORDER_STATUS_ABNORMAL;
    },

    //更新订单信息
    syncOrderInfo(orderParkingId) {
      if (orderParkingId) {
        this.$utils.showLoading();
        this.$request(
          ORDER_PARKING_SYNC_ORDER_INFO,
          { orderParkingId },
          res => {
            this.$utils.closeLoading();
            if (this.$condition.isRequestSuccess(res)) {
              // Toast(JSON.stringify(res))
              this.orderStatusFunc(res["data"]["orderParkingStatus"], () => {
                Dialog.alert({
                  title: "系统提示",
                  message: '<span style="font-size : 20px ;">请重试</span>'
                });
              });
            }
          }
        );
      }
    },

    //线下支付，弹窗
    offline(orderParkingId) {
      Dialog.confirm({
        title: "系统提示",
        message:
          "<span style='font-size : 20px ;'>请确认是否完成线下支付</span>"
      }).then(() => {
        if (orderParkingId) {
          //请求数据
          this.$request(ORDER_PARKING_OFFLINE_PAY, { orderParkingId }, res => {
            if (this.$condition.isRequestSuccess(res)) {
              this.$utils.goBack();
            }
          });
        }
      });
    },

    //确认操作
    onConfirm(orderParkingId) {
      if (orderParkingId) {
        this.$request(ORDER_PARKING_FINISH, { orderParkingId }, () => {
          Toast("订单操作成功");
          this.$utils.goBack();
        });
      }
    },

    //点击取消订单，继续计费
    onCancel(id) {
      // if (id) {
      //   //提示弹窗
      //   Dialog.confirm({
      //     title: "系统提示",
      //     message:
      //       "<span style='font-size : 20px ;'>确认取消该订单，继续计费</span>",
      //   }).then(() => {
      this.cancelBtnDisable = true;
      this.$request(ORDER_PARKING_CANCEL_ORDER, { orderParkingId: id }, res => {
        this.cancelBtnDisable = false;
        if (this.$condition.isRequestSuccess(res)) {
          // Toast("该订单已经开始继续计费");
          this.$utils.goBack();
        }
      });
      //   });
      // }
    },

    //按钮点击，回退路由
    onBtnClick() {
      //提示弹窗
      // Dialog.confirm({
      //   title: "系统提示",
      //   message: `<span style='font-size : 20px ;'>确认关闭该订单页面</span>`,
      // }).then(() => {
      this.$utils.goBack();
      // });
    },

    //点击欠费
    onOwe(id) {
      if (id) {
        //提示弹窗
        Dialog.confirm({
          title: "系统提示",
          message: "<span style='font-size : 20px ;'>确认生成欠费订单</span>"
        }).then(() => {
          //请求生成欠费订单接口
          // Toast("已生成欠费订单");

          this.$request(
            ORDER_PARKING_ARREAR_OPERATE,
            { orderParkingId: id },
            res => {
              if (this.$condition.isRequestSuccess(res)) {
                this.$utils.goBack();
              }
            }
          );
        });
      }
    },

    //二维码失败回调
    failCallback() {
      this.$router.push({
        name: "Result",
        params: {
          orderStatus: this.orderObj.orderStatus,
          oid: this.orderObj.id,
          orderAmount: (
            this.orderObj.payableAmount - this.orderObj.payAmount
          ).toFixed(2),
          isRecovery: this.isRecovery
        }
      });
    },

    successCallback() {
      // this.$utils.goBack();
      this.$router.go(0);

      this.$utils.orderParkingId(this.orderParkingId);
    },

    closeQRCode() {
      this.isFirst = false;

      this.showQRCode = false;
    },

    onShowQRCode() {
      this.qrCodeInterFace = ORDER_PARKING_QRCODE;
      this.showQRCode = true;
    },

    pageInit() {
      this.filterLoading = true;
      let { orderParkingId } = this.$route.params;

      let url = ORDER_PARKING_FIND_ORDER_PARKING_BY_ID;
      let params = {
        orderParkingId
      };

      if (orderParkingId) {
        //发起请求，获取该待处理订单信息
        this.$request(url, params, res => {
          // Dialog.alert({
          //   message: JSON.stringify(res),
          // });

          this.loadingTimeout = setTimeout(() => {
            this.$utils.closeLoading();
            this.filterLoading = false;
          }, 500);
          //获取成功
          if (this.$condition.isRequestSuccess(res)) {
            let data = res["data"];

            if (
              data["isLeave"] &&
              this.$condition.isOrderStatus_success(data["orderStatus"])
            ) {
              this.$router.replace({
                name: "Order",
                params: {
                  oid: data["id"],
                  orderStatus: data["orderStatus"]
                }
              });

              return;
            }

            for (let k in data) {
              //赋值，set方法引起页面刷新
              this.$set(this.orderObj, k, data[k]);
            }

            this.orderStatus = this.orderObj.orderStatus;
            this.parkingNumber = this.orderObj.parkingNumber;
            this.orderParkingId = this.orderObj.id;
            this.isRecovery = this.orderObj.isRecovery;

            this.orderAmount = this.orderObj.orderAmount;

            if (this.$condition.isOrderStatus_fail(this.orderStatus)) {
              this.isFirst = true;
            }

            if (this.orderObj.isRecovery) {
              this.qrCodeInterFace = ORDER_PARKING_RECOVERY_QRCODE;
              this.scanCodeInterface = ORDER_PARKING_RECOVERY_SCANCODE_PAY;
            } else {
              this.qrCodeInterFace = ORDER_PARKING_QRCODE;
              this.scanCodeInterface = ORDER_PARKING_SCANCODE_PAY;
            }
          }
        });
      }
    }
  },
  computed: {
    orderTitle() {
      if (
        this.$condition.isOrderStatus_pending(this.orderStatus) ||
        this.$condition.isOrderStatus_success(this.orderStatus) ||
        this.$condition.isOrderStatus_advance(this.orderStatus)
      ) {
        return "待处理订单";
      } else if (this.$condition.isOrderStatus_fail(this.orderStatus)) {
        return "支付失败订单";
      } else if (this.$condition.isOrderStatus_abnormal(this.orderStatus)) {
        return "支付中订单";
      }

      return "";
    }
  },
  components: {
    qrCode
  },
  watch: {
    parkingNumber(newV, oldV) {
      if (newV != oldV) {
        let str = "";
        if (newV.indexOf(",") > 0) {
          this.isShowNumberIcon = true;
          newV.split(",").forEach(item => {
            str += `<span>${item}</span>`;
          });
          this.$refs.parkingNumber.innerHTML = newV.split(",")[0];

          this.$refs.parkingNumberPop.innerHTML = str;
        } else {
          str = `<span>${newV}</span>`;
          this.$refs.parkingNumber.innerHTML = str;
        }
      }
    }
  },
  mounted() {
    // this.showQRCode = true ;
    JsBridge.registerHandler("showQRCode", () => {
      this.onShowQRCode();
    });

    // this.$nextTick( () => {
    //   //初始化better-scroll
    //   this.pendingOrderBScroll = new BScroll(this.$refs.pendingOrderBScroll, {
    //     probeType: 2,
    //     click: true,
    //   });
    // });
  },
  beforeDestroy() {
    //销毁定时器
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.payingTimeout) {
      clearTimeout(this.payingTimeout);
    }
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }

    // if (this.disabledTimer) {
    //   clearInterval(this.disabledTimer);
    // }
    // if (this.reloadTimer) {
    //   clearTimeout(this.reloadTimer);
    // }
    // if (this.pendingOrderBScroll) {
    //   clearTimeout(this.pendingOrderBScroll);
    // }
    if (this.pollRequestTimeout) {
      clearTimeout(this.pollRequestTimeout);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // vm.loading = true;
      // vm.setLoading(true) ;
      vm.$utils.showLoading();

      // vm.setTimeDisabled();

      //改变顶部状态栏
      vm.$utils.changeStatusBarStyle("black");

      //id：车位id  plateNumber：车牌号
      vm.pageInit();
    });
  }
};
</script>

<style lang="less" scoped>
.slide-enter-to,
.slide-leave {
  /*height : auto ;*/
  /*transform: translateX(0);*/
  /*width : auto ;*/
  opacity: 1;
}
.slide-enter,
.slide-leave-to {
  /*height : 0 ;*/
  /*transform: translateX(100%);*/
  /*height : 0 ;*/
  /*width : 0 ;*/
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s;
}
.pop-enter-to,
.pop-leave {
  transform: translateY(0);
  opacity: 1;
}
.pop-enter,
.pop-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.pop-enter-active,
.pop-leave-active {
  transition: all 0.3s;
}
.pendingOrder_wrapper {
  width: 100vw;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  overflow: hidden;
  padding-top: 26px;

  .icon {
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /deep/ .van-nav-bar__title {
    font-size: 20px;
  }
}

.pendingOrder_BScroll {
  position: absolute;
  top: 70px;
  bottom: 0;
  width: 100%;
  z-index: 51;
  overflow: hidden;

  .bscroll_box {
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .pendingOrder_list {
      flex: 1;
      overflow: scroll;
      position: relative;

      &.line {
        box-shadow: inset 0 -2px 5px #888888;
      }
    }
  }
}

.pendingOrder_list {
  width: 100%;
  padding: 0 14px;

  .pendingOrder_item {
    width: 100%;
    height: 66px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    color: #000;
    border-bottom: 1px solid rgba(7, 17, 27, 0.1);
    padding: 0 10px;

    /*&.item_parkingNumber_box{*/
    /*  height : auto ;*/
    /*  padding : 12px 10px ;*/
    /*}*/

    .item_content {
      flex: 1;
      text-align: right;
      color: #333;

      &.item_parkingNumber {
        position: relative;

        .parkingNumber_pop {
          font-size: 24px;
          position: absolute;
          right: 0;
          top: -10px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          background-color: #fff;
          border: 1px solid rgba(7, 17, 27, 0.1);
          padding: 10px 20px;
        }
      }
    }

    .item_icon {
      height: 100%;
      /*flex : 1 ;*/
      color: #333;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      font-size: 28px;
      /*font-weight : bold;*/
      color: #333;
    }
  }
}

.pendingOrder_pay_btn {
  width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  color: #fff;
  font-size: 20px;
  background-color: rgb(43, 95, 230);
  border-radius: 6px;
  margin-top: 20px;

  &.disabled {
    pointer-events: none;
  }

  &.payAgain {
    margin-bottom: 20px;
  }

  &.update_btn {
    margin-bottom: 20px;
  }

  &.refund_btn {
    background-color: #ee0a24;

    &:active {
      background-color: #910616;
    }
  }

  &.gray {
    color: #878d95;
    background-color: #f1f3f5;
  }

  &:active {
    background-color: rgb(13, 40, 150);
  }
}

.pendingOrder_footer {
  width: 100%;
  padding: 0 30px;
  /*border-top : 1px solid rgba( 7 , 17 , 27 ,0.1);*/
  display: flex;
  justify-content: center;

  .footer_btn_box {
    display: flex;
    justify-content: space-around;
  }

  .footer_btn {
    width: 100%;

    .pendingOrder_btn {
      font-size: 18px;
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #666;
      background-color: #ccc;
      border-radius: 2px;
      margin: 0 auto;
    }

    .continue_btn {
      margin-top: 20px;
    }

    .arrear_btn {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  .payLoading {
    margin: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    color: rgb(43, 95, 230);

    .point {
      display: block;
      width: 10px;
      height: 10px;
      // border : 1PX solid #333 ;
      border-radius: 50%;
      margin-left: 10px;
    }

    .point1_animation {
      animation: point1 1s linear 0ms infinite;
    }

    .point2_animation {
      animation: point2 1s linear 0ms infinite;
    }

    .point3_animation {
      animation: point3 1s linear 0ms infinite;
    }
  }
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 51;
  width: 100%;
  height: 100%;
  background-color: rgba(7, 17, 27, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  .van-loading {
    color: #fff;
    font-size: 24px;
  }

  .van-loading__text {
    color: #fff;
  }
}

@keyframes point1 {
  0% {
    background-color: #fff;
  }

  50% {
    background-color: rgb(43, 95, 230);
  }

  100% {
    background-color: rgb(43, 95, 230);
  }
}

@keyframes point2 {
  0% {
    background-color: rgb(43, 95, 230);
  }

  50% {
    background-color: #fff;
  }

  100% {
    background-color: rgb(43, 95, 230);
  }
}

@keyframes point3 {
  0% {
    background-color: rgb(43, 95, 230);
  }

  50% {
    background-color: rgb(43, 95, 230);
  }

  100% {
    background-color: #fff;
  }
}

.cancelBtnDisable {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}
</style>
